import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Carlos M.',
  info: '42 años, Buenos Aires',
  text: 'Siempre me sentía perdido en el taller. Ahora entiendo lo que me dicen y ya no me da miedo preguntar. El MegaPack se pagó solo con lo que ahorré en el primer service.'
}, {
  name: 'María L.',
  info: '35 años, Córdoba',
  text: 'Como mujer, los mecánicos me querían cobrar de más siempre. Con esta guía aprendí a pararme con seguridad y ahora me respetan. ¡Increíble el cambio!'
}, {
  name: 'Roberto S.',
  info: '55 años, Rosario',
  text: 'Después de 30 años manejando, pensé que sabía todo. Me di cuenta que gastaba plata en cosas que no hacían falta. Muy recomendable.'
}, {
  name: 'Laura G.',
  info: '28 años, Mendoza',
  text: 'Mi primer auto y no tenía idea de nada. Me daba pánico que se rompiera algo. Ahora sé revisar lo básico y viajo tranquila.'
}, {
  name: 'Diego P.',
  info: '48 años, La Plata',
  text: 'Gasté fortunas en reparaciones innecesarias por no saber detectar ruidos a tiempo. La guía de ruidos es oro puro.'
}];
export function TestimonialsSection() {
  return <section className="bg-gray-50 py-16 px-4" data-id="element-173">
      <div className="max-w-6xl mx-auto" data-id="element-174">
        <h2 className="text-3xl md:text-4xl font-black text-center text-gray-900 mb-12" data-id="element-175">
          Lo que dicen quienes ya lo probaron
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-176">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-177">
              <div className="flex text-yellow-400 mb-4" data-id="element-178">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-179" />)}
              </div>
              <p className="text-gray-700 mb-6 italic" data-id="element-180">"{t.text}"</p>
              <div className="border-t border-gray-100 pt-4" data-id="element-181">
                <p className="font-bold text-gray-900" data-id="element-182">{t.name}</p>
                <p className="text-sm text-gray-500" data-id="element-183">{t.info}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}